import { render, staticRenderFns } from "./RecentlyAddedCourses.vue?vue&type=template&id=e8ec3b7a&"
import script from "./RecentlyAddedCourses.vue?vue&type=script&lang=js&"
export * from "./RecentlyAddedCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports